import e from'@mui/material/Skeleton';var t=e;export{t as Skeleton};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map